import { Alignment, Button, ButtonVariant, Intent, Position, Tooltip } from "@blueprintjs/core";
import {  showToast } from ".";
import { __ } from "../utilities";

export interface IClipboardPasteProps { 
    label?: string
    position?: Position
    paste: (data: any ) => void
    iface?: any
    variant?: ButtonVariant 
    align?: Alignment
    type?: "button" | "icon"
    fill?: boolean
    className?: string
    intent? : Intent
}
const ClipboardPasteBtn = (props: IClipboardPasteProps) : JSX.Element => {
    const paste = async () => {
      await navigator.clipboard.readText()
        .then( clipText => {
          console.log( clipText )
          try {
            const menuDatas = JSON.parse( clipText ) 
            if( props.iface && menuDatas instanceof props.iface) {
                throw new Error("No correct data!")
            }
            props.paste( menuDatas )
          } 
          catch (e) {
            showToast({
              intent: Intent.DANGER,
              icon: 'tick', 
              message: __('Error read clipboard data'),
            })
          }
        })
        .catch(err => {
          // возможно, пользователь не дал разрешение на чтение данных из буфера обмена
          console.error('Something went wrong', err);
        })
    }
    return props.type === "button"    
      ?
      <Button variant={props.variant || "minimal"} onClick={ paste } fill={!!props.fill} intent={props.intent} alignText={props.align} >
          <div className={`d-flex flex-nowrap ${props.className}`}>
              <i className="fas fa-clone mr-2" /> 
              <span className={`small letter-spacing-1`}>{ __( props.label || "Paste from clipboard") }</span>
          </div>
      </Button>
      :
      <Tooltip content={ __( props.label || "Paste from clipboard") } position={props.position} >
          <div className='btn btn-link text-secondary  w-100 btn-sm ' onClick={ paste } >
              <i className="far fa-clone" /> 
          </div>
      </Tooltip>
} 

export default ClipboardPasteBtn 